// Tiered pricing data for Edible Cups
// This ensures consistent pricing across the product pages, cart, and checkout

export const PRICING_110ML = [
  { cups: 10, cartons: 1, price: 10, label: '10 cups', description: '1 carton', cupsPerCarton: 10 },
  { cups: 20, cartons: 2, price: 19.5, label: '20 cups', description: '2 cartons', cupsPerCarton: 10 },
  { cups: 30, cartons: 3, price: 28.50, label: '30 cups', description: '3 cartons', cupsPerCarton: 10 },
  { cups: 40, cartons: 4, price: 37, label: '40 cups', description: '4 cartons', cupsPerCarton: 10 },
  { cups: 50, cartons: 5, price: 46, label: '50 cups', description: '5 cartons', cupsPerCarton: 10 },
  { cups: 60, cartons: 6, price: 55, label: '60 cups', description: '6 cartons', cupsPerCarton: 10 },
  { cups: 70, cartons: 7, price: 64, label: '70 cups', description: '7 cartons', cupsPerCarton: 10 },
  { cups: 80, cartons: 8, price: 73, label: '80 cups', description: '8 cartons', cupsPerCarton: 10 },
  { cups: 90, cartons: 9, price: 82, label: '90 cups', description: '9 cartons', cupsPerCarton: 10 },
  { cups: 100, cartons: 10, price: 91, label: '100 cups', description: '10 cartons', cupsPerCarton: 10 },
  { cups: 120, cartons: 12, price: 108, label: '120 cups', description: '12 cartons', cupsPerCarton: 10 },
  { cups: 140, cartons: 14, price: 125, label: '140 cups', description: '14 cartons', cupsPerCarton: 10 },
  { cups: 160, cartons: 16, price: 142, label: '160 cups', description: '16 cartons', cupsPerCarton: 10 },
  { cups: 180, cartons: 18, price: 158, label: '180 cups', description: '18 cartons', cupsPerCarton: 10 },
  { cups: 200, cartons: 20, price: 175, label: '200 cups', description: '20 cartons', cupsPerCarton: 10 }
];

export const PRICING_220ML = [
  { cups: 12, cartons: 1, price: 13, label: '12 cups', description: '1 carton', cupsPerCarton: 12 },
  { cups: 24, cartons: 2, price: 25, label: '24 cups', description: '2 cartons', cupsPerCarton: 12 },
  { cups: 36, cartons: 3, price: 36, label: '36 cups', description: '3 cartons', cupsPerCarton: 12 },
  { cups: 48, cartons: 4, price: 46, label: '48 cups', description: '4 cartons', cupsPerCarton: 12 },
  { cups: 60, cartons: 5, price: 56, label: '60 cups', description: '5 cartons', cupsPerCarton: 12 },
  { cups: 72, cartons: 6, price: 66, label: '72 cups', description: '6 cartons', cupsPerCarton: 12 },
  { cups: 96, cartons: 8, price: 86, label: '96 cups', description: '8 cartons', cupsPerCarton: 12 },
  { cups: 120, cartons: 10, price: 106, label: '120 cups', description: '10 cartons', cupsPerCarton: 12 },
  { cups: 144, cartons: 12, price: 124, label: '144 cups', description: '12 cartons', cupsPerCarton: 12 },
  { cups: 168, cartons: 14, price: 142, label: '168 cups', description: '14 cartons', cupsPerCarton: 12 },
  { cups: 192, cartons: 16, price: 158, label: '192 cups', description: '16 cartons', cupsPerCarton: 12 },
  { cups: 216, cartons: 18, price: 174, label: '216 cups', description: '18 cartons', cupsPerCarton: 12 },
  { cups: 240, cartons: 20, price: 188, label: '240 cups', description: '20 cartons', cupsPerCarton: 12 }
];

// Get pricing tier based on product ID and number of cartons
export const getPricingForProduct = (productId) => {
  if (productId === 'edible-cup-110') {
    return PRICING_110ML;
  } else if (productId === 'edible-cup-220') {
    return PRICING_220ML;
  }
  return [];
};

// Get price for a specific number of cartons
export const getPriceForCartons = (productId, cartons) => {
  const pricing = getPricingForProduct(productId);
  const tier = pricing.find(p => p.cartons === cartons);
  return tier ? tier.price : 0;
};

// Get the tier details for a specific number of cartons
export const getTierForCartons = (productId, cartons) => {
  const pricing = getPricingForProduct(productId);
  const tier = pricing.find(p => p.cartons === cartons);
  return tier || null;
};

// Get the minimum cartons (1 carton)
export const getMinCartons = (productId) => {
  return 1;
};

// Get the maximum cartons available
export const getMaxCartons = (productId) => {
  const pricing = getPricingForProduct(productId);
  if (pricing.length === 0) return 1;
  return Math.max(...pricing.map(p => p.cartons));
};

// Get all available carton quantities for a product
export const getAvailableCartons = (productId) => {
  const pricing = getPricingForProduct(productId);
  return pricing.map(p => p.cartons);
};

// Calculate the variant string for display
export const getVariantString = (productId, cartons) => {
  const tier = getTierForCartons(productId, cartons);
  if (!tier) return '';
  return `${tier.cups} cups (${tier.cartons} ${tier.cartons === 1 ? 'carton' : 'cartons'})`;
};
